import React, {useRef} from "react";
import Select, {defaultTheme, components} from 'react-select';
import makeAnimated from 'react-select/animated';
// import './MaestroSelect.scss';

const selectTheme = {
    ...defaultTheme,
    colors: {
        ...defaultTheme.colors,
        primary: '#BD2025',
        primary25: '#FBE5E6',
        primary50: '#EE9B9D',
        primary75: '#DE3B40',
    },
};

const OptionWithCheckbox = (props) => (
    <div>
        <components.Option {...props}>
        <div className={`fake-checkbox ${props.isSelected ? 'selected' : ''}`}></div>
        <label>{props.label}</label>
        </components.Option>
    </div>
);

const GroupWithCheckbox = (props) => {
    const hasSelectedOption = props.children.some((opt) => opt.props.isSelected);
    const hasAllSelectedOptions = props.children.every((opt) => opt.props.isSelected);

    const onClick = () => {
        let newValue = props.selectProps.value ? [...props.selectProps.value] : [];

        if(!hasAllSelectedOptions) {
            // only add options that aren't already added
            for(let optVal of props.options) {
                let found = false;
                for(let objVal of newValue) {
                    if(optVal.label == objVal.label && optVal.value == objVal.value) {
                        found = true;
                        break;
                    }
                }

                if(!found) {
                    newValue.push(optVal);
                }
            }
        } else {
            // calculate the list of indexes to be removed
            let indexesToRemove = [];
            for(const valInd in newValue) {
                const newVal = newValue[valInd];

                for(const objValInd in props.options) {
                    const objVal = props.options[objValInd];

                    if(newVal.label == objVal.label && newVal.value == objVal.value) {
                        indexesToRemove.push(parseInt(valInd));
                    }
                }
            }

            // remove the indexes
            newValue = newValue.filter(function(value, index) {
                return indexesToRemove.indexOf(index) == -1;
            })
        }

        props.selectProps.onChange(newValue);
    }

    const onGroupToggle = (providedProps, e) => {
        props.selectProps.onToggleGroup(providedProps.data);
    }

    return (
        <components.Group
            {...props}
            headingProps={{ ...props.headingProps, hasSelectedOption, hasAllSelectedOptions, onClick, onGroupToggle }}
        >
            <div style={{ display: props.data.expanded ? "block" : "none" }}>{props.children}</div>
        </components.Group>
    );
  };

const GroupHeadingWithCheckbox = ({ hasSelectedOption, hasAllSelectedOptions, ...props }) => {
    const {className, onClick, ...otherProps} = props;
    const classes = `${className ? className : ''} checkbox-group-heading`;

    return <components.GroupHeading className={classes} {...otherProps}>
        <span onClick={onClick}>
            <div className={`fake-checkbox ${hasSelectedOption && 'partially-selected white'} ${hasAllSelectedOptions && 'selected white'}`}></div>
            {props.children}
        </span>
        <div className={`collapse-toggle`} onClick={(e) => {
            e.stopPropagation();
            props.onGroupToggle(props, e);
        }}>
            <div className={`chevron ${props.data.expanded ? '' : 'right'}`}></div>
        </div>
    </components.GroupHeading>;
};

const SummarizedValueContainer = ({ children, getValue, ...props }) => {
    let length = getValue().length;

    const singlularSummaryWord = props.selectProps.showValueSummary[0] || 'Item';
    const pluralSummaryWord = props.selectProps.showValueSummary[1] || 'Items';

    const currentlySelected = props.selectProps.allowSelectAll && length >= props.selectProps.options.length ? 'All' : length;

    const verbiage = `${currentlySelected} ${length === 1 ? singlularSummaryWord : pluralSummaryWord} Selected`;

    return (
        <components.ValueContainer {...props}>
            {/* {!props.selectProps.menuIsOpen && verbiage} */}
            {verbiage}
            {React.cloneElement(children[1])}
        </components.ValueContainer>
    );
};

const MaestroSelect = (props) => {
    const SearchComponent = props.component ? props.component : Select;
    let selectComponents = {
        ...makeAnimated(),
    };

    const valueRef = useRef(props.value);

    if(props.hasOwnProperty('showValueSummary')) {
        if(
            (props.hasOwnProperty('isMulti') && props.isMulti)
            ||
            (props.hasOwnProperty('showCheckboxes') && props.showCheckboxes === true)
        ) {
            try {
                const displayAfterCount = props.showValueSummary[2] || 3;
                if(props.value.length > displayAfterCount) {
                    selectComponents.ValueContainer = SummarizedValueContainer;
                }
            } catch(e){}
        }
    }

    if(props.hasOwnProperty('showCheckboxes') && props.showCheckboxes === true) {
        /*
        let restProps = {...props};

        const {
            allOption = {
                label: "Select All",
                value: "*"
            }
        } = props;

        if(props.hasOwnProperty('allowSelectAll') && props.allowSelectAll === true) {
            restProps.options = [allOption, ...props.options];

            restProps.onChange = selected => {
                // check for select all toggle
                if (selected.length > 0 && selected[selected.length - 1].value === allOption.value) {
                    console.log('SELECT ALL TOGGLED')

                    if((selected.length - 1) === props.options.length) {
                        console.log('toggle all off');
                    } else {
                        console.log('toggle all on');
                    }

                    // return props.onChange(props.options);
                }
                return props.onChange(selected);
            };

            if (props.value.length === props.options.length) {
                restProps.onChange = selected => props.onChange(selected.slice(1));
            } else {
                // restProps.options = [allOption, ...props.options];
                restProps.onChange = selected => {
                    if (
                        selected.length > 0 &&
                        selected[selected.length - 1].value === allOption.value
                    ) {
                        return props.onChange(props.options);
                    }

                    return props.onChange(selected);
                };
            }
        }
        */

        let restProps = {...props};
        if(props.hasOwnProperty('allowSelectAll') && props.allowSelectAll === true) {
            // isOptionSelected sees previous props.value after onChange
            valueRef.current = props.value;

            const selectAllOption = {
                value: "<SELECT_ALL>",
                label: "Select All"
            };

            const isSelectAllSelected = () =>
                valueRef.current.length === props.options.length;

            const isOptionSelected = option =>
                valueRef.current.some(({ value }) => value === option.value) ||
                isSelectAllSelected();

            const getOptions = () => [selectAllOption, ...props.options];

            const getValue = () =>
                isSelectAllSelected() ? [selectAllOption, ...props.value] : props.value;

            const onChange = (newValue, actionMeta) => {
                const { action, option, removedValue } = actionMeta;

                // console.log(actionMeta);

                if (action === "select-option" && option.value === selectAllOption.value) {
                    props.onChange(props.options, actionMeta);
                } else if (
                    (action === "deselect-option" && option.value === selectAllOption.value)
                    ||
                    (action === "remove-value" && removedValue.value === selectAllOption.value)
                ) {
                    props.onChange([], actionMeta);
                } else if (actionMeta.action === "deselect-option" && isSelectAllSelected()) {
                    props.onChange(
                        props.options.filter(({ value }) => value !== option.value),
                        actionMeta
                    );
                } else {
                    props.onChange(newValue || [], actionMeta);
                }
            };

            restProps.options = getOptions();
            restProps.value = getValue();
            restProps.onChange = onChange;
        }

        const checkboxComponents = {
            ...selectComponents,
            Option: OptionWithCheckbox,
            Group: GroupWithCheckbox,
            GroupHeading: GroupHeadingWithCheckbox,
        };
        return (
            <SearchComponent
                components={checkboxComponents}
                theme={selectTheme}
                isMulti={true}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                backspaceRemovesValue={false}
                menuPortalTarget={document.body}
                menuPlacement={'auto'}

                {...restProps}
            />
        );
    }

    return (
        <SearchComponent
            components={selectComponents}
            theme={selectTheme}
            styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: ({ width, ...css }) => ({
                    ...css,
                    width: "max-content",

                }),
            }}
            menuPortalTarget={document.body}
            menuPlacement={'auto'}
            {...props}
        />
    );

}

export default MaestroSelect;
